export * from "./analytics";
export * from "./animations";
export * from "./themes";
export * from "./feature-toggles";

export const DEFAULT_ENVIRONMENT = "ENVIRONMENT";
export const REDACTED = "REDACTED";
export const LOGGED_IN_USER_NO_NAME_STATUS = "loggedIn";
export const LOGGED_OUT_USER_STATUS = "loginOrRegister";
export const LOADING_STATUS = "loading";
export const VERSION = "VERSION_STRING";
export const DEFAULT_UNREAD_MESSAGES_COUNT = 0;

export const FOCUSABLE_ELEMENTS_SELECTOR =
  'a, button, [tabindex]:not([tabindex="-1"]), phn-p-link-pure, phn-p-button-pure, phn-p-link, phn-p-button, input.autofocus, phn-p-inline-notification';

export const GEOLOCATION_BUTTON_SEARCH_TERM = "by geolocation";
export const DEALER_MARKET_SEARCH_TERM = "by market";

// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const MS_IN_MONTH = 1000 * 60 * 60 * 24 * 90;

export const COOKIE_DOMAIN = "porsche.com";

export const MenuItemVariant = {
  Model: "model-variant",
  Level1: "level1-variant",
  DealerDetails: "dealer-details-variant",
} as const;

export const DEFAULT_LOCALE = "";
